import React from "react";
import styled from "styled-components";

const Grid = styled.div<{ $columns?: number; $minTileWidth: number }>`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$columns !== undefined
      ? `repeat(${props.$columns}, 1fr)`
      : `repeat(auto-fill, minmax(${props.$minTileWidth}px, 1fr))`};
  gap: 8px;
`;

interface AppTileGridProps {
  children: React.ReactNode;
  columns?: number;
  minTileWidth?: number;
}

const AppTileGrid: React.FC<AppTileGridProps> = ({ children, columns, minTileWidth = 140 }) => (
  <Grid $columns={columns} $minTileWidth={minTileWidth}>
    {children}
  </Grid>
);

export default AppTileGrid;
